module.exports = __webpack_public_path__ + "img/dentist_thumbnail-400x300.23acf1ca.jpg";